// extracted by mini-css-extract-plugin
export default {"wrapper":"PricingPage_wrapper__VwjbK"};